import React, {useState, useEffect} from "react"
import {useSelector, useDispatch} from "react-redux"

import Input from "./Input"

import {
  setLeftWorkAreaState,
  clearLeftWorkAreaState,
} from "../../../redux/actions/product2dActions"

import "./leftworktext.scss"

const defaultTextColor = "#000"
const defaultFont = "Times New Roman"
const defaultOutline = null

/**
 * Form for text editing
 * @component
 * @example
 * return (
 *  <Form />
 * )
 */

const Form = () => {
  const [text, setText] = useState("")
  const [color, setColor] = useState(defaultTextColor)
  const [font, setFont] = useState(defaultFont)
  const [outline, setOutline] = useState(defaultOutline)
  // const [arc, setArc] = useState(0)
  const [size, setSize] = useState(30)
  const [spacing, setSpacing] = useState(30)
  const [rotate, setRotate] = useState(0)
  const [rand, setRand] = useState(1)
  const [scale, setScale] = useState(100)

  const dispatch = useDispatch()
  const makFabric = useSelector(state => state.makFabric)

  /**
   * Change text
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleChange = ({target}) => {
    if (makFabric && makFabric.getSelectedText()) {
      setText(target.value)
      makFabric.updateText(makFabric.getSelectedText(), target.value)
    }
  }

  // const handleUpdateText = e => {
  //   e.preventDefault()
  //   if (text.trim() === "") return
  //   if (makFabric && makFabric.getSelectedText()) {
  //     makFabric.updateText(makFabric.getSelectedText(), text)
  //   }
  // }

  /**
   * Align text
   * @param {object} e - element
   */
  const handleAlignText = e => {
    e.preventDefault()
    if (text.trim() === "") {
      return
    } else {
      makFabric.setTextAlign(makFabric.getSelectedText(), e.target.name)
    }
  }

  const openStep = e => {
    e.preventDefault()
    if (text !== "") {
      console.log(e.target.name)
      dispatch(clearLeftWorkAreaState())
      dispatch(setLeftWorkAreaState(e.target.name))
    }
  }

  // const handleArc = e => {
  //   if (text.trim() === "") return
  //   e.preventDefault()
  //   e.target.name === "plus" && setArc(prev => parseInt(prev) + 1)
  //   e.target.name === "minus" && setArc(prev => parseInt(prev) - 1)
  // }
  /**
   * Change csale with button
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleScale = e => {
    if (text.trim() === "") return
    e.preventDefault()
    e.target.name === "plus" && setScale(prev => parseInt(prev) + 1)
    e.target.name === "minus" && setScale(prev => parseInt(prev) - 1)
  }

  /**
   * Change rotation with button
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleRotate = e => {
    if (text.trim() === "") return
    e.preventDefault()
    e.target.name === "plus" && setRotate(prev => parseInt(prev) + 1)
    e.target.name === "minus" && setRotate(prev => parseInt(prev) - 1)
  }

  /**
   * Change size with button
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleSize = e => {
    if (text.trim() === "") return
    e.preventDefault()
    e.target.name === "plus" && setSize(prev => parseInt(prev) + 1)
    e.target.name === "minus" && setSize(prev => parseInt(prev) - 1)
  }

  /**
   * Change letter spacing with button
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleSpacing = e => {
    if (text.trim() === "") return
    e.preventDefault()
    e.target.name === "plus" && setSpacing(prev => parseInt(prev) + 1)
    e.target.name === "minus" && setSpacing(prev => parseInt(prev) - 1)
  }

  // const changeArc = ({target}) => {
  //   if (text.trim() === "") return
  //   setArc(target.value.replace(/[^+\d]/g, ""))
  // }
  /**
   * Change scale
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const changeScale = ({target}) => {
    if (text.trim() === "") return
    setScale(target.value.replace(/[^+\d]/g, ""))
  }
  /**
   * Change rotation
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const changeRotate = ({target}) => {
    if (text.trim() === "") return
    setRotate(target.value.replace(/[^+\d]/g, ""))
  }
  /**
   * Change size
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const changeSize = ({target}) => {
    if (text.trim() === "") return
    setSize(target.value.replace(/[^+\d]/g, ""))
  }
  /**
   * Change latter spacing
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const changeSpacing = ({target}) => {
    if (text.trim() === "") return
    setSpacing(target.value.replace(/[^+\d]/g, ""))
  }

  useEffect(() => {
    if (makFabric && makFabric.getSelectedText() && rand) {
      setText(makFabric.getSelectedText().text)
      setColor(makFabric.getSelectedText().fill)
      setFont(makFabric.getSelectedText().fontFamily)
      setRotate(makFabric.getSelectedText().angle)
      setSize(makFabric.getSelectedText().fontSize)
      setSpacing(makFabric.getSelectedText().charSpacing)
      setOutline(makFabric.getSelectedText().stroke)
      setScale(makFabric.getSelectedText().scaleX * 100)
    }
  }, [makFabric, rand])

  useEffect(() => {
    if (makFabric && rotate) {
      makFabric.getSelectedText() &&
        makFabric.rotateObject(makFabric.getSelectedText(), rotate)
    }
  }, [makFabric, rotate])

  useEffect(() => {
    if (makFabric && size) {
      makFabric.getSelectedText() &&
        makFabric.setFontSize(makFabric.getSelectedText(), size)
    }
  }, [makFabric, size])

  useEffect(() => {
    if (makFabric && spacing) {
      makFabric.getSelectedText() &&
        makFabric.setFontSpacing(makFabric.getSelectedText(), spacing)
    }
  }, [makFabric, spacing])

  // useEffect(() => {
  //   if (makFabric && arc) {
  //     makFabric.getSelectedText() &&
  //       makFabric.setDiametr(makFabric.getSelectedText(), arc)
  //   }
  // }, [makFabric, spacing])

  useEffect(() => {
    if (makFabric && scale) {
      makFabric.getSelectedText() &&
        makFabric.scaleObject(makFabric.getSelectedText(), scale)
    }
  }, [makFabric, scale, spacing])

  useEffect(() => {
    if (makFabric) {
      makFabric.help.selectedObj = () => setRand(Math.random() * 100)
    }
    return () => (makFabric.help.selectedObj = () => {})
  }, [makFabric])

  return (
    <div className="leftWorkTextFormContainer">
      <div className="leftWorkTextInptContainer">
        <textarea
          className="leftWorkTextText"
          type="text"
          value={text}
          placeholder="Enter text"
          onChange={handleChange}
        ></textarea>
      </div>

      <div className="leftWorkTextBtnContainer">
        <button
          className="leftWorkTextTrigerBtn"
          name="SELECT_FONT"
          onClick={openStep}
        >
          <span className="leftWorkTextBtnTitle">Font</span>
          <div className="leftWorkTextTrigerBtn_flex">
            <span className="leftWorkTextBtnTitle" style={{fontFamily: font}}>
              {font}
            </span>
            <img src="/images/icons/chevron-down.svg" alt="" />
          </div>
        </button>
      </div>

      <div className="leftWorkTextBtnContainer">
        <button
          className="leftWorkTextTrigerBtn"
          name="SELECT_COLOR"
          onClick={openStep}
        >
          <span className="leftWorkTextBtnTitle">Text Color</span>
          <div className="leftWorkTextTrigerBtn_flex">
            <span
              className="leftWorkTextColorCircle"
              style={{backgroundColor: color}}
            ></span>
            <img src="/images/icons/chevron-down.svg" alt="" />
          </div>
        </button>
      </div>

      <div className="leftWorkTextBtnContainer">
        <button
          className="leftWorkTextTrigerBtn"
          name="SELECT_OUTLINE"
          onClick={openStep}
        >
          <span className="leftWorkTextBtnTitle">Outline</span>
          <div className="leftWorkTextTrigerBtn_flex">
            {!outline ? (
              <span className="leftWorkTextBtnTitle">None</span>
            ) : (
              <span
                className="leftWorkTextColorCircle"
                style={{backgroundColor: outline}}
              ></span>
            )}

            <img src="/images/icons/chevron-down.svg" alt="" />
          </div>
        </button>
      </div>

      <div className="leftWorkTextBtnContainer">
        <div className="leftWorkTextTrigerBlock">
          <span className="leftWorkTextBtnTitle">Text Alignment</span>
          <div className="leftWorkTextTrigerBtn_flex">
            <button
              className="leftWorkTextAlignBtn"
              name="left"
              onClick={handleAlignText}
            >
              l
            </button>
            <button
              className="leftWorkTextAlignBtn"
              name="center"
              onClick={handleAlignText}
            >
              c
            </button>
            <button
              className="leftWorkTextAlignBtn"
              name="right"
              onClick={handleAlignText}
            >
              r
            </button>
          </div>
        </div>
      </div>

      <div className="leftWorkTextControlsCont">
        {
          //   <div className="leftWorkTextControlsCont_item">
          //   <span className="leftWorkTextControlsCont_title">Arc</span>
          //   <Input
          //     value={arc}
          //     name="arc"
          //     handler={handleArc}
          //     changes={changeArc}
          //   />
          // </div>
        }
        <div className="leftWorkTextControlsCont_item">
          <span className="leftWorkTextControlsCont_title">Scale</span>
          <Input
            value={scale}
            name="scale"
            handler={handleScale}
            changes={changeScale}
          />
        </div>

        <div className="leftWorkTextControlsCont_item">
          <span className="leftWorkTextControlsCont_title">Spacing</span>
          <Input
            value={spacing}
            name="spacing"
            handler={handleSpacing}
            changes={changeSpacing}
          />
        </div>

        <div className="leftWorkTextControlsCont_item">
          <span className="leftWorkTextControlsCont_title">Font size</span>
          <Input
            value={size}
            name="size"
            handler={handleSize}
            changes={changeSize}
          />
        </div>

        <div className="leftWorkTextControlsCont_item">
          <span className="leftWorkTextControlsCont_title">Rotate</span>
          <Input
            value={rotate}
            name="rotate"
            handler={handleRotate}
            changes={changeRotate}
          />
        </div>
      </div>
    </div>
  )
}

export default Form
